import React from 'react'
import { WhatsappTicketsView } from '../components/whatsapp/WhatsappTicketsView'

const WhatsappFarma: React.FC = () => (
  <WhatsappTicketsView
    origin="pasi-farma"
    moduleName="atendimentos_whatsapp_farma"
    title="Whatsapp Farma"
  />
)

export default WhatsappFarma
